import { combineReducers } from 'redux';

import { FileError, ImportManagerAction, ImportManagerActionKeys } from './actions';
import Utils from '../../utils';

export interface ImportFileState {
	id?: string;
	folderId?: number;
	file?: File;
	percentage?: number;
	error?: FileError | null;
	isProcessing?: boolean;
	isImportFinished?: boolean;
	isImportCanceled?: boolean;
	shouldDisplayInToast?: boolean;
}

interface ByIdState {
	[key: string]: ImportFileState;
}

export interface ImportManagerState {
	byId: ByIdState;
	filesQueue: string[];
	remainingImportTime: number;
}

export const byId = (state: ByIdState = {}, action: ImportManagerAction): ByIdState => {
	switch (action.type) {
		case ImportManagerActionKeys.ADD_FILE_IN_IMPORT:
			return {
				...state,
				[action.id]: {
					...state[action.id],
					...action.data,
				},
			};
		case ImportManagerActionKeys.ADD_FILES_IN_IMPORT: {
			const filesList = action.files.map((file, index) => ({
				id: action.ids[index],
				folderId: action.folderId,
				file,
				percentage: 0,
				error: null,
				shouldDisplayInToast: true,
			}));
			return {
				...state,
				...Utils.itemsToById(filesList),
			};
		}
		case ImportManagerActionKeys.UPDATE_FILE_IN_IMPORT:
			if (!state[action.id]) {
				return state;
			}
			return {
				...state,
				[action.id]: {
					...state[action.id],
					...action.data,
				},
			};
		case ImportManagerActionKeys.REMOVE_FILE_FROM_IMPORT: {
			const { [action.id]: id, ...rest } = state;
			return { ...rest };
		}
		case ImportManagerActionKeys.REMOVE_FILES_FROM_IMPORT: {
			const newState = { ...state };
			for (let id in newState) {
				if (action.ids.includes(id)) {
					delete newState[id];
				}
			}
			return newState;
		}
		case ImportManagerActionKeys.CANCEL_FILES_IMPORT: {
			const newState = { ...state };
			for (let id in newState) {
				if (action.ids.includes(id)) {
					newState[id] = {
						...newState[id],
						isImportCanceled: true,
					};
				}
			}
			return newState;
		}
		case ImportManagerActionKeys.RESTART_FILES_IMPORT: {
			const newState = { ...state };
			for (let id in newState) {
				if (action.ids.includes(id)) {
					newState[id] = {
						...newState[id],
						isImportCanceled: false,
						percentage: 0,
					};
				}
			}
			return newState;
		}
		default:
			return state;
	}
};

export const filesQueue = (state: string[] = [], action: ImportManagerAction): string[] => {
	switch (action.type) {
		case ImportManagerActionKeys.ADD_TO_FILES_QUEUE:
			return [
				...state,
				...action.ids,
			];
		case ImportManagerActionKeys.REMOVE_FROM_FILES_QUEUE: {
			const index = state.findIndex(id => id === action.id);
			return [
				...state.slice(0, index),
				...state.slice(index + 1),
			];
		}
		case ImportManagerActionKeys.CANCEL_FILES_IMPORT:
		case ImportManagerActionKeys.REMOVE_FILES_FROM_IMPORT:
			return [];
		default:
			return state;
	}
};

export const remainingImportTime = (state: number = 0, action: ImportManagerAction): number => {
	switch (action.type) {
		case ImportManagerActionKeys.UPDATE_REMAINING_IMPORT_TIME:
			return action.time;
		case ImportManagerActionKeys.CANCEL_FILES_IMPORT:
		case ImportManagerActionKeys.REMOVE_FILES_FROM_IMPORT:
			return 0;
		default:
			return state;
	}
};

export const importManager = combineReducers<ImportManagerState>({
	byId,
	filesQueue,
	remainingImportTime,
});




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ImportManager/reducer.ts